import * as React from 'react'
import Helmet from 'react-helmet'

import { APP_NAME } from '../../static/constants'
import dateFormat from '../../services/data/dateFormat'
import { doGetGCashReferralCode } from '../../controllers/GCash'
import { setGAEvent } from '../../services/analytics/google-analytics'
import downloadAppLink from '../../services/redirection/downloadAppLink'
import {
  MainContainer,
  ContentContainer,
  BannerImage,
  Title,
  Description,
  CodeContainer,
  PromoCode,
  Copy,
  StoreBubbles,
  Store,
  Instructions,
  InstructionsList,
  InstructionsListItem,
  InstructionsTitle,
  InstructionsValidity,
  DownloadLabel,
  TncLink,
  Footer,
  SpinnerContainer,
  FlexWrapper,
  StyledImage,
} from './MainView.style'
// Assets
import AppStore from '../../assets/img/app-download/app-store.png'
import PlayStore from '../../assets/img/app-download/play-store.png'
import Banner from '../../assets/img/gcash/GCashxZing@1x.png'
import ReferralImage from '../../assets/img/referral-image.webp'
import Icon from '../../components/ui/Icon/Icon'
import Spinner from '../../components/ui/Spinner/Spinner'

const zingTnC = '/webview/terms-and-conditions'
function MainView({ accessToken }) {
  const [loading, setLoading] = React.useState(true)
  const [error, setError] = React.useState(null)
  const [promoDetails, setPromoDetails] = React.useState(null)

  const getPromoDetails = async () => {
    await doGetGCashReferralCode({
      accessToken,
      onSuccess: response => {
        setPromoDetails(response)
        setLoading(false)
      },
      onError: error => {
        if (
          error.response &&
          (error.response.status === 422 || error.response.status === 404)
        ) {
          setError('Page Not Found')
        } else {
          setError('Failed to Load. Please try again later')
        }
        setLoading(false)
      },
    })
  }
  const handleCopy = () => {
    // document.getElementById('referralCode').select()
    // document.execCommand('copy')
    navigator.clipboard.writeText(promoDetails && promoDetails.referralCode)
  }
  const trackLinkOut = label => {
    setGAEvent('button_cta', 'GCash x Zing Referral', label)
  }

  React.useEffect(() => {
    getPromoDetails()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  if (error) {
    return (
      <FlexWrapper>
        <Title style={{ textAlign: 'center' }}>{error}</Title>
        <StyledImage src={ReferralImage} alt="Page Not Found" />
      </FlexWrapper>
    )
  }

  return loading ? (
    <FlexWrapper>
      <SpinnerContainer>
        <Spinner />
      </SpinnerContainer>
    </FlexWrapper>
  ) : (
    <MainContainer>
      <Helmet>
        <style>
          {`
            .adsbygoogle {
              display: none !important;
            }
          `}
        </style>
      </Helmet>
      <BannerImage src={Banner} />
      <ContentContainer>
        <Title>Zing your way with GCash</Title>
        <Description>
          Download and register to {APP_NAME} and get&nbsp;
          <b>100 Zing Points</b>
          &nbsp;when you use the referral code below.
        </Description>
        {promoDetails ? (
          <CodeContainer>
            <PromoCode>
              {/* <HiddenInput
                readonly
                id="referralCode"
                value={promoDetails && promoDetails.referralCode}
              /> */}
              {(promoDetails && promoDetails.referralCode) || ' -- '}
            </PromoCode>
            <Copy onClick={handleCopy}>
              <Icon name="copy" style={{ height: '1.5em' }} />
            </Copy>
          </CodeContainer>
        ) : (
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        )}
        <Instructions>
          <InstructionsTitle>HOW TO USE THE CODE:</InstructionsTitle>
          <InstructionsList>
            <InstructionsListItem>Download {APP_NAME}</InstructionsListItem>
            <InstructionsListItem>
              Register and use the referral code
            </InstructionsListItem>
            <InstructionsListItem>
              Link your GCash number to your Zing account to get 100 Zing Points
              (receive within 24 to 48 hours)
            </InstructionsListItem>
          </InstructionsList>
          <InstructionsValidity>
            Valid until {promoDetails && dateFormat(promoDetails.endDate)}
          </InstructionsValidity>
        </Instructions>
        <DownloadLabel>DOWNLOAD THE APP NOW!</DownloadLabel>
        <StoreBubbles>
          <Store src={AppStore} onClick={downloadAppLink('iOS')} alt="" />
          <Store src={PlayStore} onClick={downloadAppLink('Android')} alt="" />
        </StoreBubbles>
      </ContentContainer>
      <Footer>
        <p>
          By using the referral code, you agree to the program &nbsp;
          <TncLink
            target="_blank"
            rel="noopener noreferrer"
            href={zingTnC} // link to terms and conditions
            title={`${APP_NAME} Terms and Conditions`}
            onClick={() => trackLinkOut(`${APP_NAME} Terms and Conditions`)}
          >
            {APP_NAME} Terms &amp; Conditions.
          </TncLink>
        </p>
        <p>DTI PERMIT No. 12345</p>
        <br />
      </Footer>
    </MainContainer>
  )
}

export default MainView
